// S110 : sessionStorage et non localStorage. Le mot de passe admin y est en clair ;
// en sessionStorage il disparaît à la fermeture de l'onglet au lieu de rester sur le
// poste indéfiniment.
const AUTH_STORAGE_KEY = 'email_dashboard_auth';

export const authService = {
  isLoggedIn(): boolean {
    const auth = sessionStorage.getItem(AUTH_STORAGE_KEY);
    return !!auth;
  },

  getCredentials(): { username: string; password: string } | null {
    const auth = sessionStorage.getItem(AUTH_STORAGE_KEY);
    if (!auth) return null;
    
    try {
      return JSON.parse(auth);
    } catch {
      return null;
    }
  },

  async login(username: string, password: string): Promise<boolean> {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL || 'https://email-classification.expnt.dev'}/admin/health`,
        {
          headers: {
            'Authorization': 'Basic ' + btoa(`${username}:${password}`)
          }
        }
      );

      if (response.ok) {
        sessionStorage.setItem(
          AUTH_STORAGE_KEY,
          JSON.stringify({ username, password })
        );
        return true;
      }
      
      return false;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  },

  logout() {
    sessionStorage.removeItem(AUTH_STORAGE_KEY);
  }
};